"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Star = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StarVector = styled_components_1.default.svg `
  vertical-align: text-top;
`;
const Star = (props) => {
    return (react_1.default.createElement(StarVector, { "aria-hidden": "true", stroke: "#bf9343", strokeWidth: "2", height: "1.1em", fill: props.fill, viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        react_1.default.createElement("defs", null,
            react_1.default.createElement("linearGradient", { id: "StarGradient" },
                react_1.default.createElement("stop", { offset: "0%", stopColor: "#F2B03E" }),
                react_1.default.createElement("stop", { offset: "100%", stopColor: "#F7CA45" })),
            react_1.default.createElement("linearGradient", { id: "HalfStarGradient" },
                react_1.default.createElement("stop", { stopOpacity: "1", offset: "0%", stopColor: "#F2B03E" }),
                react_1.default.createElement("stop", { stopOpacity: "1", offset: "50%", stopColor: "#F7CA45" }),
                react_1.default.createElement("stop", { stopOpacity: "0", offset: "50%", stopColor: "#F7CA45" }))),
        react_1.default.createElement("path", { d: "M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118\n               l11.547-1.2L16.026,0.6L20.388,10.918z" })));
};
exports.Star = Star;
